import { get } from 'lodash';
import { useFormState, UseFormStateProps } from 'react-hook-form-7';

import { ReportFormValues } from '../types/ReportFormTypes';

export default function useQuestionErrors(
  formStateProps: UseFormStateProps<ReportFormValues>
) {
  const { errors } = useFormState(formStateProps);

  const questionError = get(errors, formStateProps.name);
  const isInvalid = !!questionError;
  const errorMessage = questionError?.message;

  return { isInvalid, errorMessage };
}
